"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileDtoKycStatusEnum = exports.UserProfileDtoGenderEnum = void 0;
exports.instanceOfUserProfileDto = instanceOfUserProfileDto;
exports.UserProfileDtoFromJSON = UserProfileDtoFromJSON;
exports.UserProfileDtoFromJSONTyped = UserProfileDtoFromJSONTyped;
exports.UserProfileDtoToJSON = UserProfileDtoToJSON;
exports.UserProfileDtoToJSONTyped = UserProfileDtoToJSONTyped;
var AvatarDto_1 = require("./AvatarDto");
/**
 * @export
 */
exports.UserProfileDtoGenderEnum = {
    Male: 'male',
    Female: 'female',
    Other: 'other'
};
/**
 * @export
 */
exports.UserProfileDtoKycStatusEnum = {
    Verified: 'verified',
    RequiresInput: 'requires_input',
    Canceled: 'canceled',
    Processing: 'processing',
    Expired: 'expired'
};
/**
 * Check if a given object implements the UserProfileDto interface.
 */
function instanceOfUserProfileDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function UserProfileDtoFromJSON(json) {
    return UserProfileDtoFromJSONTyped(json, false);
}
function UserProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'username': json['username'] == null ? undefined : json['username'],
        'bio': json['bio'] == null ? undefined : json['bio'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'kycStatus': json['kycStatus'] == null ? undefined : json['kycStatus'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'avatar': json['avatar'] == null ? undefined : (0, AvatarDto_1.AvatarDtoFromJSON)(json['avatar']),
        'isVerified': json['isVerified'] == null ? undefined : json['isVerified'],
        'isSocialLogin': json['isSocialLogin'] == null ? undefined : json['isSocialLogin'],
        'authProviderId': json['authProviderId'] == null ? undefined : json['authProviderId'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deletedAt': json['deletedAt'] == null ? undefined : json['deletedAt'],
        'deletedBy': json['deletedBy'] == null ? undefined : json['deletedBy'],
        'isDisabled': json['isDisabled'] == null ? undefined : json['isDisabled'],
        'disabledAt': json['disabledAt'] == null ? undefined : json['disabledAt'],
        'disabledBy': json['disabledBy'] == null ? undefined : json['disabledBy'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'residentialAddress': json['residentialAddress'] == null ? undefined : json['residentialAddress'],
        'interests': json['interests'] == null ? undefined : json['interests'],
    };
}
function UserProfileDtoToJSON(json) {
    return UserProfileDtoToJSONTyped(json, false);
}
function UserProfileDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'email': value['email'],
        'fullName': value['fullName'],
        'username': value['username'],
        'bio': value['bio'],
        'gender': value['gender'],
        'kycStatus': value['kycStatus'],
        'dateOfBirth': value['dateOfBirth'],
        'countryCode': value['countryCode'],
        'phoneNumber': value['phoneNumber'],
        'avatar': (0, AvatarDto_1.AvatarDtoToJSON)(value['avatar']),
        'isVerified': value['isVerified'],
        'isSocialLogin': value['isSocialLogin'],
        'authProviderId': value['authProviderId'],
        'isDeleted': value['isDeleted'],
        'deletedAt': value['deletedAt'],
        'deletedBy': value['deletedBy'],
        'isDisabled': value['isDisabled'],
        'disabledAt': value['disabledAt'],
        'disabledBy': value['disabledBy'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'residentialAddress': value['residentialAddress'],
        'interests': value['interests'],
    };
}
